export default __webpack_public_path__ + "static/media/File No. 26.e9ac1706.pdf";